import React from 'react';

import {
  ReferralCodeContainer,
  DateActiveContainer,
  StatisticsContainer,
  ChartsContainer,
  StructureContainer,
  // AutoBonusContainer,
} from 'containers';

import styles from './styles.module.scss';

export const PartnerPage = () => (
  <div className={styles.partner_page}>
    <div className={styles.top_container}>
      <div className={styles.referral_code_container}>
        <ReferralCodeContainer />
        <DateActiveContainer />
      </div>
      <StatisticsContainer />
    </div>
    <ChartsContainer />
    <StructureContainer />
    {/* <AutoBonusContainer /> */}
  </div>
);
